var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import { TableContainer } from '@mui/material';
import { Delimiter } from '../../atoms/Delimiter';
import { declineVote } from '../../../api';
import { setMatchState } from '../../../store/match';
import { useAppDispatch } from '../../../hooks';
import { useErrorHandler } from '../../../hooks/useErrorHandler';
const votesStyle = {
    color: '#FD7D6B',
    fontWeight: 700,
};
const tableStyle = {
    width: '454px',
    borderRadius: '12px',
    boxShadow: '0px 6px 18px 0px rgba(0, 0, 0, 0.39)',
};
const Content = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 330px;
`;
const getPlayerName = (players, playerId) => {
    if (playerId === null) {
        return 'Пас';
    }
    const found = players.find((p) => p.id === playerId);
    if (found) {
        return `${found.player.gameName} (${found.player.realName})`;
    }
    return 'Игрок не найден';
};
export function VotesList({ votes, players, dayNumber, voteItems, previousVote }) {
    const dispatch = useAppDispatch();
    const { errorHandler } = useErrorHandler();
    const onVoteDecline = (voteId, currentVoteId) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield declineVote(voteId, currentVoteId);
            dispatch(setMatchState(response));
        }
        catch (err) {
            errorHandler(err);
        }
    });
    return (_jsxs(Content, { children: [_jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u0418\u0442\u043E\u0433\u0438 \u0433\u043E\u043B\u043E\u0441\u043E\u0432\u0430\u043D\u0438\u044F" })), _jsx(Delimiter, { top: "34px" }), _jsx(TableContainer, { children: _jsxs(Table, Object.assign({ sx: tableStyle }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u0418\u043C\u044F" })), _jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0433\u043E\u043B\u043E\u0441\u043E\u0432" }))] }) }), _jsx(TableBody, { children: votes.map((vote) => (_jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "body", sx: votesStyle }, { children: getPlayerName(players, vote.playerId) })), _jsx(TableCell, Object.assign({ variant: "body", sx: votesStyle }, { children: vote.votes }))] }, vote.playerId))) })] })) }), _jsx(Delimiter, { top: "34px" }), _jsx(TableContainer, { children: _jsxs(Table, Object.assign({ sx: tableStyle }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ sx: { width: '62px' }, variant: "head" }, { children: "\u2116" })), _jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u041A\u0442\u043E" })), _jsx(TableCell, Object.assign({ variant: "head" }, { children: "\u0412 \u043A\u043E\u0433\u043E" }))] }) }), _jsx(TableBody, { children: voteItems.map((vote) => (_jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ sx: { width: '62px' }, variant: "body" }, { children: vote.position })), _jsx(TableCell, Object.assign({ variant: "body" }, { children: getPlayerName(players, vote.voterId) })), _jsx(TableCell, Object.assign({ variant: "body" }, { children: vote.isFinished && getPlayerName(players, vote.targetId) }))] }, vote.id))) })] })) }), _jsx(Delimiter, { top: "20px" })] }));
}
